import type { TrustedKey } from '@slate/plugin-api';

/**
 * Host-configured trusted signer keys. v1 ships EMPTY: no first-party signing
 * key has been issued yet (key issuance is Part 6). Until then no sealed
 * third-party plugin can pass verification, which is the correct fail-closed
 * posture (none ship in v1; the first-party example runs in-process and skips
 * signing per spec 4.1). Part 6 appends the issued first-party public key here.
 */
export const FIRST_PARTY_KEYS: TrustedKey[] = [];

/** Read a sealed plugin's bytes from the locked-down `plugin://` origin. No
 *  `@tauri-apps/*` import: the custom scheme is fetched like any URL. */
export async function pluginFetchReadFile(pluginId: string, path: string): Promise<Uint8Array> {
  const res = await fetch(`plugin://${pluginId}/${path}`);
  if (!res.ok) throw new Error(`plugin asset ${pluginId}/${path}: ${res.status}`);
  return new Uint8Array(await res.arrayBuffer());
}
